import React, { Component } from "react";
import { Accordion, Table } from "semantic-ui-react";
import _ from "lodash";
import VehicleInfo from "./VehicleInfo";
import { getOtherDetailsRows } from "./VehicleOtherDetails";
import VehiclePhotos from "./VehiclePhotos";
import { getAllRows } from "../ReportElementHelper";

class VehicleDetails extends Component {
  state = {
    rows: [],
    activeIndex: -1,
  };

  getAllElements = () => {
    const rowTables = [];
    const vehicleRegistrants = _.get(
      this.props.record,
      "vehicleRegistrants[0].vehicleRegistrant"
    );
    if (vehicleRegistrants && vehicleRegistrants.length > 0) {
      _.forEach(vehicleRegistrants, (record, index) => {
        const recs = [];
        getAllRows(
          record,
          recs,
          this.props,
          _.get(record, "$.display"),
          0,
          undefined,
          true
        );
        if (recs.length > 0) {
          rowTables.push(
            <Table.Row key={`${this.props.sectionName}_${index}`}>
              <Table.Cell>
                <Table>
                  <Table.Body>
                    <Table.Row>
                      <Table.HeaderCell
                        colSpan={2}
                        className="report-sub-section-header"
                      >
                        Registrant
                      </Table.HeaderCell>
                    </Table.Row>
                    {recs}
                  </Table.Body>
                </Table>
              </Table.Cell>
            </Table.Row>
          );
        }
      });
    }
    return rowTables;
  };

  handleClick = () => {
    if (this.state.activeIndex === 0) {
      this.setState({ activeIndex: -1 });
    } else {
      this.setState({ activeIndex: 0 });
    }
  };

  render() {
    return (
      <Accordion fluid styled>
        <Accordion.Title
          active={this.state.activeIndex === 0}
          key={`veh_details_title_${this.props.detailIndex}`}
          onClick={() => this.handleClick()}
        >
          <p>
            Details for {_.get(this.props.record, "modelYear[0]._")}&#160;
            {_.get(this.props.record, "make[0]._")}&#160;
            {_.get(this.props.record, "model[0]._")}
            <span className={"icon-toggle-accordion"}>
              {this.state.activeIndex === 0 ? "-" : "+"}
            </span>
          </p>
        </Accordion.Title>
        <Accordion.Content
          key={`veh_details_body_${this.props.detailIndex}`}
          active={this.state.activeIndex === 0}
        >
          <Table className="table-no-border-and-padding">
            <Table.Body>
              <Table.Row>
                <Table.Cell>
                  <VehicleInfo {...this.props} />
                </Table.Cell>
              </Table.Row>
              {_.get(
                this.props.record,
                "vehicleRegistrants[0].vehicleRegistrant[0]"
              ) && (
                <Table.Row>
                  <Table.Cell>
                    <Table>
                      <Table.Body>
                        <Table.Row>
                          <Table.HeaderCell
                            key={`veh_det_title`}
                            colSpan={4}
                            className="report-sub-section-header"
                          >
                            <center>Registrants</center>
                          </Table.HeaderCell>
                        </Table.Row>
                        {this.getAllElements()}
                      </Table.Body>
                    </Table>
                  </Table.Cell>
                </Table.Row>
              )}
              <Table.Row>
                <Table.Cell>
                  <Table>
                    <Table.Body>
                      <Table.Row>
                        <Table.HeaderCell
                          key={`veh_det_title`}
                          colSpan={4}
                          className="report-sub-section-header"
                        >
                          <center>VIN Summary Details</center>
                        </Table.HeaderCell>
                      </Table.Row>
                      {getOtherDetailsRows(
                        this.props.record,
                        this.props.detailIndex
                      )}
                    </Table.Body>
                  </Table>
                </Table.Cell>
              </Table.Row>

              <Table.Row>
                <Table.Cell>
                  <VehiclePhotos {...this.props} />
                </Table.Cell>
              </Table.Row>
            </Table.Body>
          </Table>
        </Accordion.Content>
      </Accordion>
    );
  }
}

export default VehicleDetails;



// WEBPACK FOOTER //
// ./src/components/reports/Silver/VehicleDetails.js